<template>
  <vs-popup class="customer-create-popup"
            id="popup"
            title="CREATE CUSTOMER ORGANIZATION"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <vx-card subtitle="Organization Details" cardBorder>
            <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Name</small>
                <vs-input v-model="createForm.company_name"   name="company_name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="account_currency" name="account_currency" rules="required" v-slot="{ errors }">
                <small class="label">Currency</small>
                <v-select :clearable="false" label="code" v-model="createForm.account_currency" :reduce="option => option.code" :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2 hidden">
              <ValidationProvider vid="stage" name="stage" rules="required" v-slot="{ errors }">
                <small class="label">Stage</small>
                <v-select :clearable="false" label="name" v-model="createForm.stage" :reduce="option => option.value" :options="customerStages" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="site_telephone" name="site_telephone" rules="required" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="createForm.country_code_main_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="telephone" name="telephone" rules="required|tel|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Main Telephone</small>
                <vs-input  v-model="createForm.main_telephone" class="w-full"  name="telephone" type="text" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row hidden" v-can="'create-edit-sage-customer'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sage" name="sage" rules="required" v-slot="{ errors }">
                <small class="label">Sage customer</small>
                <v-select v-on:input="onChangeSage()" name="sage" :closeOnSelect="true"
                          v-model="sage" :clearable="false"
                          label="name" :reduce=" option => option.value"
                          :options="[{name: 'none', value: 0}, {name: 'create new customer', value: 1}, {name: 'link to existing sage customer', value: 2}]" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div v-if="sage === 2" class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="existing_sage_id" name="existing_sage_id" rules="required" v-slot="{ errors }">
                <small class="label">Existing sage customers</small>
                <v-select :clearable="false" label="name" v-model="existing_sage_id" :reduce="option => option.id" :options="sage_customers" :dir="$vs.rtl ? 'rtl' : 'ltr'" @search="onSearch">
                  <template v-slot:option="option">
                    <span>{{option.name}} - {{option.reference}} </span>
                  </template>
                  <template slot="no-options">
                    type to search sage customer
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <small class="label">OTIF Tracked</small>
              <vs-switch v-model="createForm.is_otif_tracked" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
          </vx-card>
          <vx-card subtitle="User Details" cardBorder class="mt-4">
            <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createForm.first_name"   name="first_name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input  v-model="createForm.last_name" class="w-full"  name="last_name" type="text" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createForm.email"   name="email" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="types" name="types" rules="" v-slot="{ errors }">
                <small class="label">Nimble User Role</small>
                <v-select name="role_id" label="name" :closeOnSelect="true"  :reduce="option => option.value" v-model="createForm.types" 
                  :options="customer_user_types" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="role_id" name="role_id" rules="" v-slot="{ errors }">
                <small class="label">Customer Portal Role</small>
                <v-select name="role_id" label="name" :closeOnSelect="true"  :reduce="option => option.id" v-model="createForm.role_id" :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          </vx-card>
         
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="resetForm" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SageRepository = RepositoryFactory.get('sage')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const StaffRepository = RepositoryFactory.get('staff')
  const CustomerRepository = RepositoryFactory.get('customer')
  import { mapActions, mapGetters } from 'vuex'

  function initialState() {
    return {
      open: false,
      createForm: {
        stage: 'customer',
        types: [],
        is_otif_tracked: false
      },
      countryCodes: [],
      currencies: [],
      roles: [],
      sage: 0,
      sage_customers: [],
      existing_sage_id: null,
      created_customer: {}
    }
  }

export default {
  name: 'CreateCustomerPopUp',
  data () {
    return initialState()
  },
  methods:{
    ...mapActions(['fetchCustomerUserTypes']),
    resetForm () {
      this.createForm = {
        stage: 'customer',
        types: [],
        is_otif_tracked: false
      }
      this.$refs.form && this.$refs.form.reset();
    },
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        await this.loadCountrCode()
        await this.loadCurrencies()
        await this.fetchRoles()
        await this.fetchCustomerUserTypes()
        this.open = true;
      } catch (error) {

      }
    },

    async loadCountrCode() {
      this.$vs.loading()
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close()
    },
    async loadCurrencies() {
      this.$vs.loading()
      const {data} =  (await StaffRepository.getCurrencyList()).data
      this.currencies =  data
      this.$vs.loading.close()
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         const { data } = (await CustomerRepository.createCustomer(this.createForm)).data
         this.created_customer = data
        //  await this.createSageCustomer()
        //  this.showSuccessMessage('New customer created successfully')
        //  await vue.$parent.refreshData()
         this.open = false;
         this.$router.push({path: `/pages/manage-nimble/customers/${this.created_customer.id}`})
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async fetchRoles() {
      this.$vs.loading()
      const {data} = (await CustomerRepository.getCustomerRoles()).data
      this.roles = data
      this.$vs.loading.close()
    },
    async onChangeSage() {
      if(this.sage === 2) {
        // await this.fetchSageCustomers()
      }
    },
    async createSageCustomer () {
      try {
        if(this.sage === 1){
          const sage_currency_id = await this.sageCurrencyMapper(this.created_customer.account_currency)

          let payload = {}
          payload.currency_id = sage_currency_id
          payload.name = this.created_customer.company_name
          payload.reference = this.created_customer.account_number !== '-' ? this.created_customer.account_number.match(/\d+/)[0] : this.created_customer.company_name
          payload.on_hold = false
          payload.telephone_country_code = this.created_customer.country_code_main_telephone
          payload.telephone_subscriber_number = this.created_customer.main_telephone
          await SageRepository.createCustomer(this.created_customer.id, payload)
        } else if(this.sage === 2) {
          await SageRepository.linkSageCustomer(this.created_customer.id, { sage_id: this.existing_sage_id })
        }
      }catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    // async fetchSageCustomers() {
    //   this.$vs.loading()
    //   try {
    //     this.sage_customers =  (await SageRepository.getSageCustomers()).data.data
    //   } catch (e) {
    //     if(e.response.status === 401) {
    //       this.sage = 0
    //       this.showErrorMessage('Authorization has been denied from sage')
    //     }
    //   }
    //   this.$vs.loading.close()
    // },
    onSearch: function (search, loading) {
      if(search.length) {
        loading(true);
        this.fetchSageCustomers(loading, search, this);
      }
    },
    fetchSageCustomers: _.debounce( async (loading, search, vm) => {
      try {
        vm.sage_customers =  (await SageRepository.getSageCustomers(`filter[name]=${search}`)).data.data
      } catch (e) {
        if(e.response.status === 401) {
          vm.sage = 0
          vm.showErrorMessage('Authorization has been denied from sage')
        }
      }
      loading(false);
    }, 350),
    async sageCurrencyMapper(code) {
      const currencyMap = {
        'GBP': 'Pound Sterling',
        'USD': 'US Dollar',
        'EUR': 'Euro',
        'AUD': 'Australian Dollar',
        'DKK': 'Danish Krone'
      };
      const currencyName = currencyMap[code];
      const sage_currency_list =  (await SageRepository.getCurrencies()).data.data
      const sageCurrencyObj = sage_currency_list.find(currency => currency.name === currencyName);
      return sageCurrencyObj ? sageCurrencyObj.id : null
    },
  },
  computed: {
    ...mapGetters(['customer_user_types']),
    customerStages: function () {
      if(this.$can('create-edit-customer')) {
        return [
          {name: 'Opportunity', value: 'opportunity'},
          {name: 'Lead', value: 'lead'},
          {name: 'Subscriber', value: 'subscriber'},
          {name: 'Customer', value: 'customer'}
        ]
      } else if(this.$can('sales-crm-access')) {
        return [
          {name: 'Opportunity', value: 'opportunity'},
          {name: 'Lead', value: 'lead'},
          {name: 'Subscriber', value: 'subscriber'},
        ]
      }
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
